import React from "react";
import TabbedPage from "../../../../shared/ui/TabbedPage";
import TargetsTab from "../../components/TargetsTab";

export default function TargetsSettingsPage() {
  return (
    <TabbedPage
      title="تنظیمات تارگت"
      defaultTab="targets"
      placeholderText="بخش مورد نظر را انتخاب کنید"
      tabs={[{ id: "targets", label: "تارگت‌ها", component: TargetsTab }]}
    />
  );
}
